import { SpotMatchRecord, SpotOrderRecord, TradingFeeRates } from 'api/v1/spot'
import { Ether } from 'types'

export interface SpotClosedOrders {
  list: SpotOrderRecord[]
  isLastPage: boolean
  offsetId: number
}
export interface SpotMatchClearingsType {
  list: SpotMatchRecord[]
  isLastPage: boolean
  offsetId: number
}

export interface SpotState {
  currentSpotSymbol: number
  feeRates: TradingFeeRates | undefined
  openOrders: SpotOrderRecord[]
  badgeOrder: boolean
  badgeTrade: boolean
  createOrderOption: CreateOrderOption
  orderMode: OrderModeNames
  lastInputAmountType: LastInputAmountType
  orderDirection: OrderDirection
  cancelSpotPendingIds: number[]
  orderTab: SpotOrderTabType
  closedOrders: SpotClosedOrders
  matchClearings: SpotMatchClearingsType
  cancelAllOpenSpotState: boolean
  postOnly: boolean
}
export interface CreateOrderOption {
  limitPrice: Ether
  baseCurrencyAmount: Ether
  quoteCurrencyAmount: Ether
}
export enum LastInputAmountType {
  BaseCurrency,
  QuoteCurrency,
}
export enum OrderDirection {
  LONG = 'LONG',
  SHORT = 'SHORT',
}
export enum OrderType {
  LIMIT = 'LIMIT',
  MARKET = 'MARKET',
}
export enum OrderModeNames {
  Limit = 'Limit',
  Market = 'Market',
  StopLimit = 'Stop Limit',
  StopMarket = 'Stop Market',
  Iceberg = 'Iceberg',
}
export interface OrderModeDetail {
  name: OrderModeNames
  orderType: OrderType
  dropdown: boolean // an option in a dropdown menu
}

export const OrderModeDetails: OrderModeDetail[] = [
  {
    name: OrderModeNames.Limit,
    orderType: OrderType.LIMIT,
    dropdown: false,
  },
  {
    name: OrderModeNames.Market,
    orderType: OrderType.MARKET,
    dropdown: false,
  },
  {
    name: OrderModeNames.StopLimit,
    orderType: OrderType.LIMIT,
    dropdown: false,
  },
  {
    name: OrderModeNames.StopMarket,
    orderType: OrderType.MARKET,
    dropdown: false,
  },
  // {
  //   name: OrderModeNames.Iceberg,
  //   orderType: OrderType.LIMIT,
  //   dropdown: true,
  // },
]

export enum SpotOrderTabType {
  OpenOrder = 'OpenOrder',
  OrderHistory = 'OrderHistory',
  TradeHistory = 'TradeHistory',
}

export enum SpotOrderTypeFilterEnum {
  All = 'All',
  Limit = 'Limit',
  StopLimit = 'Stop Limit',
  StopMarket = 'Stop Market',
  TakeProfitLimit = 'Take Profit Limit',
  TakeProfitMarket = 'Take Profit Market',
}

export enum SpotOrderDirectionFilterEnum {
  All = '',
  LONG = 'LONG',
  SHORT = 'SHORT',
}

export enum SpotOrderStatusFilterEnum {
  All = '',
  FAILED = 'FAILED', // Order is failed to execute (e.g. market order with no market price).
  FULLY_FILLED = 'FULLY_FILLED', // Limit order is fully filled (filledAmount = amount, do not in order book) or market order is filled.
  PARTIAL_FILLED = 'PARTIAL_FILLED', // Limit order is partially filled (amount > filledAmount > 0) and still in order book as maker.
  PARTIAL_CANCELLED = 'PARTIAL_CANCELLED', // ONLY for limit order / stop limit order: order is partially cancelled and done as final status (amount > filledAmount > 0).
  FULLY_CANCELLED = 'FULLY_CANCELLED',
}
